import * as _ from 'lodash'
import {
    HorizAlignment,
    ISearch, ISearchProfile, ISearchProvider, ISearchProviderField,
    ISearchRequestSubset, SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import { PASearch, ISearchRequest } from "../PA.Core/PASearch";
import { SearchUtils } from "../PA.UIM.Core/SearchUtils";
import { ColumnNodeProvider } from "../PA.UIM.Core/SearchTreeUtils";
import { PAEnvironment } from "../PA.Core/PAEnvironment";


const ProductSearch: ISearch = {
    searchName: "Find Product",
    renderOptions: { ui5ResourceId: "ProductSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: []
};

const vUI_Product_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_PROD_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center },
        domainOptions: {}
    },
    PRODUCT_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    PRODUCT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    PRODUCT_SET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Set ID', columnResourceName: 'colSetID', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 10 }
    },
    SOURCE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Source ID', columnResourceName: 'colSourceID', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    // PRODUCT_TYPE:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Type', columnResourceName: 'colProductType', alignment: HorizAlignment.Left}, domainOptions: { domainIds: "Product_Type", useIdAsKey: true, maxLength: 50}},
    WB_PROD_TYPE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Product Type',
            columnResourceName: 'colWBProductType',
            alignment: HorizAlignment.Left
        },
        domainOptions: { domainIds: "Product_Type", useIdAsKey: true, maxLength: 50 }
    },
    PRODUCT_UPC: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Product UPC',
            columnResourceName: 'colProductUPC',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    CONSUMER_PRODUCT_UPC: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Cons Product UPC',
            columnResourceName: 'colConsProductUPC',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    STATUS_CODE: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Status Code',
            columnResourceName: 'colStatusCode',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    WEIGHT_FACTOR: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Weight Factor',
            columnResourceName: 'colWeightFactor',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    WB_MDSET_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: 'MDSET ID', columnResourceName: 'colMDSetId', alignment: HorizAlignment.Center },
        domainOptions: {}
    },
    GTIN: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'GTIN', columnResourceName: 'colGTIN', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },

};

const vUI_Product_Search_Fields_ProductGroup: { [id: string]: ISearchProviderField } = {
    PRODUCT_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Product Id', columnResourceName: 'colId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    PRODUCT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Product Name', columnResourceName: 'colName', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    PRODUCT_GROUP_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Product Group Id',
            columnResourceName: 'colPGId',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    PRODUCT_GROUP_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Product Group Name',
            columnResourceName: 'colPGName',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    LEVEL_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Level Id', columnResourceName: 'colPGLvl', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    STATUS_CODE: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Status Code',
            columnResourceName: 'colStatusCode',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    }
};

const vUI_Product_Search_Fields_External: { [id: string]: ISearchProviderField } = {
    WB_PROD_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Center },
        domainOptions: {}
    },
    PRODUCT_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    EXTERNAL_PRODUCT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'External Name',
            columnResourceName: 'colExternalName',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },
    EXT_MANUFACTURER_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'External Manufacturer Name',
            columnResourceName: 'colExtManufName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: ProductSearch,
            profileId: "ProductSearchProfileByExternalProduct",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 10
        }
    },
    EXT_CATEGORY_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'External Category Name',
            columnResourceName: 'colExtCatName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: ProductSearch,
            profileId: "ProductSearchProfileByExternalProduct",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    EXT_BRAND_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'External Brand Name',
            columnResourceName: 'colExtBrandName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: ProductSearch,
            profileId: "ProductSearchProfileByExternalProduct",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    EXT_SEGMENT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'External Segment Name',
            columnResourceName: 'colExtSegName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: ProductSearch,
            profileId: "ProductSearchProfileByExternalProduct",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    EXT_FORM_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'External Form Name',
            columnResourceName: 'colExtFormName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: ProductSearch,
            profileId: "ProductSearchProfileByExternalProduct",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    EXT_PACKAGE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'External Package Name',
            columnResourceName: 'colExtPackageName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: ProductSearch,
            profileId: "ProductSearchProfileByExternalProduct",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    EXT_PACKAGESIZE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'External Package Size Name',
            columnResourceName: 'colExtPackageSizeName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: ProductSearch,
            profileId: "ProductSearchProfileByExternalProduct",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    EXT_PRODUCTSIZE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'External Product Size Name',
            columnResourceName: 'colExtProdSizeName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: ProductSearch,
            profileId: "ProductSearchProfileByExternalProduct",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
    EXT_SIZE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'External Size Name',
            columnResourceName: 'colExtSizeName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: ProductSearch,
            profileId: "ProductSearchProfileByExternalProduct",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 50
        }
    },
};

const vUI_Product_Search_Error_Records: { [id: string]: ISearchProviderField } = {
    WB_PROD_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Id', columnResourceName: 'colId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    PRODUCT_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'ID', columnResourceName: 'colId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    PRODUCT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    PRODUCT_GROUP_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Product Group ID',
            columnResourceName: 'colProductGroupId',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    PRODUCT_GROUP_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Product Group Name',
            columnResourceName: 'colProductGroupName',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    EFFECTIVE_START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Effective Start Date',
            columnResourceName: 'colEffectiveStartDate',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    EFFECTIVE_END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Effective End Date',
            columnResourceName: 'colEffectiveEndDate',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    // WB_PRD_HEIR_ID:  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Heir ID', columnResourceName: 'colPrdHeirId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    // WB_PRD_HEIR_NAME:  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Heir Name', columnResourceName: 'colPrdHeirName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    ERROR_REASON: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Error', columnResourceName: 'colErrorReason', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    }
};

const vUI_Product_Search_BOM_Diagnosis: { [id: string]: ISearchProviderField } = {
    PRODUCT_SET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Product Set ID', columnResourceName: 'colSetId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    PRODUCT_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'ID', columnResourceName: 'colId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    PRODUCT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    WB_PROD_TYPE_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Prod Type WB ID',
            columnResourceName: 'colProdTypeWbId',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    STATUS_CODE: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Status Code',
            columnResourceName: 'colStatusCode',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    CASE_PACK_SIZE: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Case Pack Size',
            columnResourceName: 'colCasePackSize',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    CONSUMER_PACK_UPC: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Consumer Pack UPC',
            columnResourceName: 'colConsumerPackSize',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    COMPONENT_QTY: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Component Qty',
            columnResourceName: 'colComponentQty',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    COMPONENT_UPC: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Component UPC',
            columnResourceName: 'colComponentUPC',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    COMPONENT_UOM: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Component UOM',
            columnResourceName: 'colComponentUOM',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    COMPONENT_PRODUCT_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Component Product ID',
            columnResourceName: 'colComponentProductID',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    COMPONENT_SET_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Component Set ID',
            columnResourceName: 'colComponentSetID',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    COMPONENT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Component Name',
            columnResourceName: 'colComponentName',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
};

const ProductSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_PROD_ID',
        id_ui: 'PRODUCT_ID',
        name: 'PRODUCT_NAME'
    },


    searchProviderFields: vUI_Product_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Product_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

};

const ProductSearchProviderByProductGroups: ISearchProvider = {

    keyFields: {
        id: 'WB_PROD_ID',
        id_ui: 'PRODUCT_ID',
        name: 'PRODUCT_NAME'
    },


    searchProviderFields: vUI_Product_Search_Fields_ProductGroup,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Product_Search_ByProductGroup',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
};

const ProductSearchProviderExternal: ISearchProvider = {

    keyFields: {
        id: 'WB_PROD_ID',
        id_ui: 'PRODUCT_ID',
        name: 'EXTERNAL_PRODUCT_NAME'
    },


    searchProviderFields: vUI_Product_Search_Fields_External,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Product_UPC_External_Attribute_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_Product_UPC_External_Attribute_Search',
                this.searchProviderFields,
                [fieldName])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {

                    resolve(_.map(res, (aRow) => {
                        return aRow[fieldName]
                    }))
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

}


const ProductSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "ProductSearchProfileByName" },

    profileFilter: [
        { profileFilterName: 'Id', searchProviderFieldId: 'PRODUCT_ID', renderOptions: {} },
        { profileFilterName: 'Name', searchProviderFieldId: 'PRODUCT_NAME', renderOptions: {} },
        { profileFilterName: 'Set ID', searchProviderFieldId: 'PRODUCT_SET_ID', renderOptions: {} },
        {
            profileFilterName: 'Product Type',
            searchProviderFieldId: 'WB_PROD_TYPE_ID',
            bMultiSelect: true,
            renderOptions: {}
        },
        { profileFilterName: 'Product UPC', searchProviderFieldId: 'PRODUCT_UPC', renderOptions: {} },
        { profileFilterName: 'Consumer UPC', searchProviderFieldId: 'CONSUMER_PRODUCT_UPC', renderOptions: {} },
        { profileFilterName: 'Status Code', searchProviderFieldId: 'STATUS_CODE', renderOptions: {} },
        { profileFilterName: 'GTIN', searchProviderFieldId: 'GTIN', renderOptions: {} }

    ],  // ISearchFields
    profileDisplayFields: [
        'PRODUCT_ID', 'PRODUCT_NAME', 'PRODUCT_SET_ID', 'SOURCE_ID', 'WB_PROD_TYPE_ID', 'PRODUCT_UPC', 'CONSUMER_PRODUCT_UPC', 'GTIN', 'STATUS_CODE'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductSearchProviderBasic,
    profileTreeIdDefault: "default",
    profileTrees: [
        {
            treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {
                defaultValues: "Tree Path not set",
                levelDelimiter: "\\",
                ruggedTree: true
            })],
            renderOptions: { ui5: { leafIcon: "sap-icon://Chart-Tree-Map" } }
        }
    ],
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};


const ProductSearchProfileByStatusCode: ISearchProfile = {
    profileId: "GTINMapping",
    profileName: "Search by Type, Id, Name",
    renderOptions: { ui5ResourceId: "ProductSearchProfileByStatusCode" },

    profileFilter: [
        { profileFilterName: 'Product Type', searchProviderFieldId: 'WB_PROD_TYPE_ID', renderOptions: {} },
        { profileFilterName: 'Id', searchProviderFieldId: 'PRODUCT_ID', renderOptions: {} },
        { profileFilterName: 'Name', searchProviderFieldId: 'PRODUCT_NAME', renderOptions: {} }
    ],  // ISearchFields
    profileDisplayFields: [
        'PRODUCT_ID', 'PRODUCT_NAME', 'WB_PROD_TYPE_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductSearchProviderBasic,
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ProductSearchProfileByProductGroups: ISearchProfile = {
    profileId: "ProductSearchProfileByProductGroups",
    profileName: "Search by ProductGroup",
    renderOptions: { ui5ResourceId: "ProductSearchProfileByProductGroups" },

    profileFilter: [
        { profileFilterName: 'Product Group Id', searchProviderFieldId: 'PRODUCT_GROUP_ID', renderOptions: {} },
        { profileFilterName: 'Product Group Name', searchProviderFieldId: 'PRODUCT_GROUP_NAME', renderOptions: {} },
        { profileFilterName: 'Product Id', searchProviderFieldId: 'PRODUCT_ID', renderOptions: {} },
        { profileFilterName: 'Product Name', searchProviderFieldId: 'PRODUCT_NAME', renderOptions: {} },
    ],  // ISearchFields
    profileDisplayFields: [
        'PRODUCT_ID', 'PRODUCT_NAME', 'STATUS_CODE', 'PRODUCT_GROUP_ID', 'PRODUCT_GROUP_NAME', 'LEVEL_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductSearchProviderByProductGroups,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};


const ProductSearchProfileBySource: ISearchProfile = {
    profileId: "default",
    profileName: "Search by ProductType",
    renderOptions: { ui5ResourceId: "ProductSearchProfileByProductType" },

    profileFilter: [
        { profileFilterName: 'ProductType', searchProviderFieldId: 'PRODUCT_TYPE', renderOptions: {} }
    ],  // ISearchFields
    profileDisplayFields: [
        'WB_PROD_ID', 'PRODUCT_ID', 'PRODUCT_NAME', 'PRODUCT_SET_ID', 'SOURCE_ID', 'PRODUCT_TYPE', 'PRODUCT_UPC', 'CONSUMER_PRODUCT_UPC', 'STATUS_CODE'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

var ProductSearchProfileByExternalProduct: ISearchProfile = {
    profileId: "ProductSearchProfileByExternalProduct",
    profileName: "Search by External Attributes",
    renderOptions: { ui5ResourceId: "ProductSearchProfileByExternalProduct" },

    profileFilter: [
        {
            profileFilterName: 'Manufacturer',
            searchProviderFieldId: 'EXT_MANUFACTURER_NAME',
            bMultiSelect: true,
            renderOptions: {}
        },
        { profileFilterName: 'Brand', searchProviderFieldId: 'EXT_BRAND_NAME', bMultiSelect: true, renderOptions: {} },
        {
            profileFilterName: 'Segment',
            searchProviderFieldId: 'EXT_SEGMENT_NAME',
            bMultiSelect: true,
            renderOptions: {}
        },
        {
            profileFilterName: 'Category',
            searchProviderFieldId: 'EXT_CATEGORY_NAME',
            bMultiSelect: true,
            renderOptions: {}
        },
        { profileFilterName: 'Form', searchProviderFieldId: 'EXT_FORM_NAME', bMultiSelect: true, renderOptions: {} },
        {
            profileFilterName: 'Package',
            searchProviderFieldId: 'EXT_PACKAGE_NAME',
            bMultiSelect: true,
            renderOptions: {}
        },
        { profileFilterName: 'Size', searchProviderFieldId: 'EXT_SIZE_NAME', bMultiSelect: true, renderOptions: {} }
    ],  // ISearchFields
    profileDisplayFields: [
        'PRODUCT_ID', 'EXTERNAL_PRODUCT_NAME', 'EXT_MANUFACTURER_NAME', 'EXT_CATEGORY_NAME', 'EXT_BRAND_NAME', 'EXT_SEGMENT_NAME', 'EXT_FORM_NAME', 'EXT_PACKAGE_NAME', 'EXT_PACKAGESIZE_NAME', 'EXT_PRODUCTSIZE_NAME', 'EXT_SIZE_NAME'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductSearchProviderExternal,
    profileTreeIdDefault: "ByCategoryManufacturerBrandSegment",
    profileTrees: [
        {
            treeId: "ByCategoryManufacturerBrandSegment",
            treeName: "By Category, Manufacturer, Brand, Segment, Form",
            nodeProviders: [new ColumnNodeProvider(['EXT_CATEGORY_NAME', 'EXT_MANUFACTURER_NAME', 'EXT_BRAND_NAME', 'EXT_SEGMENT_NAME', 'EXT_FORM_NAME'], { defaultValues: "Not Set" })],
            renderOptions: {}
        },
        {
            treeId: "ByCategorySegmentFormBrand",
            treeName: "By Category, Segment, Form, Brand",
            nodeProviders: [new ColumnNodeProvider(['EXT_CATEGORY_NAME', 'EXT_SEGMENT_NAME', 'EXT_FORM_NAME', 'EXT_BRAND_NAME'], { defaultValues: "Not Set" })],
            renderOptions: {}
        },
        {
            treeId: "ByCategorySegmentFormBrandSize",
            treeName: "By Category, Segment, Form, Brand, Size",
            nodeProviders: [new ColumnNodeProvider(['EXT_CATEGORY_NAME', 'EXT_SEGMENT_NAME', 'EXT_FORM_NAME', 'EXT_BRAND_NAME', 'EXT_SIZE_NAME'], { defaultValues: "Not Set" })],
            renderOptions: {}
        }
    ],

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const ProductSearchProviderErrorRecords: ISearchProvider = {

    keyFields: {
        id: 'WB_PROD_ID',
        id_ui: 'PRODUCT_ID',
        name: 'PRODUCT_NAME'
    },


    searchProviderFields: vUI_Product_Search_Error_Records,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vWB_ProdR_Dup',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

}

const ProductSearchProfileByErrorRecords: ISearchProfile = {
    profileId: "ProductSearchProfileByErrorRecords",
    profileName: "Error Records",
    renderOptions: { ui5ResourceId: "ProductSearchProfileByErrorRecords" },

    profileFilter: [
        { profileFilterName: 'Id', searchProviderFieldId: 'PRODUCT_ID', renderOptions: {} },
    ],  // ISearchFields
    profileDisplayFields: [
        'PRODUCT_ID', 'PRODUCT_NAME', 'PRODUCT_GROUP_ID', 'PRODUCT_GROUP_NAME', 'EFFECTIVE_START_DT', 'EFFECTIVE_END_DT', 'ERROR_REASON'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductSearchProviderErrorRecords,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const ProductSearchProviderBOMDiagnosis: ISearchProvider = {

    keyFields: {
        id: 'PRODUCT_ID',
        id_ui: 'PRODUCT_ID',
        name: 'PRODUCT_NAME'
    },


    searchProviderFields: vUI_Product_Search_BOM_Diagnosis,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            debugger
            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Product_BOM_Diagnostic',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

}

var ProductSearchProfileByBOMDiagnosis: ISearchProfile = {
    profileId: "ProductSearchProfileByBOMDiagnosis",
    profileName: "BOM Diagnosis",
    renderOptions: { ui5ResourceId: "ProductSearchProfileByBOMDiagnosis" },

    profileFilter: [
        { profileFilterName: 'Id', searchProviderFieldId: 'PRODUCT_ID', renderOptions: {} },
        { profileFilterName: 'Name', searchProviderFieldId: 'PRODUCT_NAME', renderOptions: {} },
    ],  // ISearchFields
    profileDisplayFields: [
        'PRODUCT_ID', 'PRODUCT_NAME', 'PRODUCT_SET_ID', 'WB_PROD_TYPE_ID', 'STATUS_CODE', 'CASE_PACK_SIZE', 'CONSUMER_PRODUCT_UPC', 'COMPONENT_QTY',
        'COMPONENT_UOM', 'COMPONENT_PRODUCT_ID', 'COMPONENT_SET_ID', 'COMPONENT_NAME'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductSearchProviderBOMDiagnosis,

    profileTreeIdDefault: "default",
    profileTrees: [
        {
            treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [new ColumnNodeProvider(['TREE_PATH'], {
                defaultValues: "Tree Path not set",
                levelDelimiter: "\\",
                ruggedTree: true
            })],
            renderOptions: { ui5: { leafIcon: "sap-icon://Chart-Tree-Map" } }
        }
    ],
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

ProductSearch.searchProfiles = [ProductSearchProfileByName, ProductSearchProfileByProductGroups, ProductSearchProfileByExternalProduct, ProductSearchProfileByErrorRecords, ProductSearchProfileByBOMDiagnosis, ProductSearchProfileByStatusCode]
PAEnvironment.registerBusinessObjectSearch("ProductBO", "Product", ProductSearch, "Product Search")

export { ProductSearch }